"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTableCellLayoutContextValues_unstable", {
    enumerable: true,
    get: ()=>useTableCellLayoutContextValues_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function useTableCellLayoutContextValues_unstable(state) {
    const { avatarSize  } = state;
    const avatar = _react.useMemo(()=>({
            size: avatarSize
        }), [
        avatarSize
    ]);
    return {
        avatar
    };
} //# sourceMappingURL=useTableCellLayoutContextValues.js.map

//# sourceMappingURL=useTableCellLayoutContextValues.js.map